import { ReactComponent as ResumeSvg } from '@/baseui/c1/icons/resume.svg';
import { ReactComponent as PrimaryEvaluationSvg } from '@/baseui/c1/icons/primary-evaluation.svg';
import { ReactComponent as ResumeEvaluationSvg } from '@/baseui/c1/icons/resume-evaluation.svg';
import { ReactComponent as OfferLetterHornSvg } from '@/baseui/c1/icons/offer-letter-horn.svg';
import { ReactComponent as PreliminaryEvaluationSvg } from '@/baseui/c1/icons/preliminary-evaluation.svg'
import { ReactComponent as PendingOnboardSvg } from '@/baseui/c1/icons/pending-onboard.svg'

export const UserStatus = {
    // ---------------- 招聘阶段 ----------------
    /** 招聘：初筛 */
    RECRUIT_INITIAL_SCREENING: 1,
    /** 简历：人才储备 */
    TALENT_POOL: 15,
    /** 招聘：认证  初评 */
    RECRUIT_CERTIFICATION: 2,
    /** 招聘：面试 */
    RECRUIT_ONLINE_INTERVIEW: 3,
    /** 招聘：线下面试 */
    // RECRUIT_OFFLINE_INTERVIEW: 4,
    /** 招聘：待录用 */
    // RECRUIT_PENDING_HIRE: 5,
    /** 招聘：待录用，需要发offer */
    PENDING_OFFER: 5,
    /** 招聘：待接受 */
    // PENDING_ACCEPTED: 18,
    /** 招聘：待报到 */
    RECRUIT_PENDING_ONBOARD: 6,

    // ---------------- 在职状态 ----------------
    /** 在职：正式 */
    EMPLOYED_FORMAL: 7,
    /** 在职：试用 */
    EMPLOYED_PROBATION: 8,
    /** 在职：实习 */
    EMPLOYED_INTERNSHIP: 9,
    /** 在职：试岗 */
    PART_TIME_JOB: 19,

    // ---------------- 历史状态 ----------------
    /** 历史：未录用 */
    HISTORY_NOT_HIRED: 10,
    /** 历史：未报到 */
    HISTORY_NOT_ONBOARD: 11,
    /** 历史：离职 */
    HISTORY_RESIGNED: 12,

    // ---------------- 外协类型 ----------------
    /** 外协：外包 */
    OUTSOURCE_CONTRACTOR: 13,
    /** 外协：顾问 */
    OUTSOURCE_CONSULTANT: 14,

    // 招聘状态集合
    RECRUIT_STATUS_LIST: [
        1, 2, 3, 4, 5, 6, 15,
    ],

    // 在应聘状态集合
    APPLYING_STATUS_LIST: [
        1, 2, 3, 4, 5, 6
    ],

    // 在职员工状态集合
    STAFF_STATUS_LIST: [
        7, 8, 9, 19
    ],
}

// 招聘阶段状态选项
export const RecruitOptions = [
    { value: UserStatus.RECRUIT_INITIAL_SCREENING, label: '网申' },
    { value: UserStatus.RECRUIT_CERTIFICATION, label: '初评' },
    { value: UserStatus.RECRUIT_ONLINE_INTERVIEW, label: '面试' },
    { value: UserStatus.PENDING_OFFER, label: '录用' },
    // { value: UserStatus.PENDING_ACCEPTED, label: '待接受' },
    { value: UserStatus.RECRUIT_PENDING_ONBOARD, label: '报到' },
]

// 人才库专用状态选项
export const TalentPoolOptions = [
    { value: UserStatus.TALENT_POOL, label: '人才储备' },
    { value: UserStatus.HISTORY_NOT_HIRED, label: '已拒绝' },
]

export const UserOptions = [
    // 招聘阶段
    { value: UserStatus.RECRUIT_INITIAL_SCREENING, label: '网申' },
    { value: UserStatus.RECRUIT_CERTIFICATION, label: '初评' },
    { value: UserStatus.RECRUIT_ONLINE_INTERVIEW, label: '面试' },
    // { value: UserStatus.RECRUIT_OFFLINE_INTERVIEW, label: '线下面试' },
    // { value: UserStatus.RECRUIT_PENDING_HIRE, label: '待录用' },
    { value: UserStatus.PENDING_OFFER, label: '录用' },
    { value: UserStatus.RECRUIT_PENDING_ONBOARD, label: '报到' },

    // 在职状态
    { value: UserStatus.EMPLOYED_FORMAL, label: '正式' },
    { value: UserStatus.EMPLOYED_PROBATION, label: '试用' },
    { value: UserStatus.EMPLOYED_INTERNSHIP, label: '实习' },
    { value: UserStatus.PART_TIME_JOB, label: '试岗' },

    // 历史状态
    { value: UserStatus.HISTORY_NOT_HIRED, label: '未录用' },
    { value: UserStatus.HISTORY_NOT_ONBOARD, label: '未报到' },
    { value: UserStatus.HISTORY_RESIGNED, label: '离职' },

    // 外协类型
    { value: UserStatus.OUTSOURCE_CONTRACTOR, label: '外包' },
    { value: UserStatus.OUTSOURCE_CONSULTANT, label: '顾问' },
];

// 在职员工的工作状态
export const EmployedUserOptions = [
    { value: UserStatus.EMPLOYED_FORMAL, label: '正式' },
    { value: UserStatus.EMPLOYED_PROBATION, label: '试用' },
    { value: UserStatus.EMPLOYED_INTERNSHIP, label: '实习' },
    { value: UserStatus.PART_TIME_JOB, label: '试岗' },
    { value: UserStatus.HISTORY_RESIGNED, label: '离职' },
]

export function getUserStatusLabel(status: number): string {
    return UserOptions.find(item => item.value == status)?.label;
}

// 是否为招聘阶段
export function isRecruitStatus(status: number): boolean {
    return UserStatus.RECRUIT_STATUS_LIST.includes(status);
}
// 是否为外协人员
export function isOutsource(userStatus: number): boolean {
    return [UserStatus.OUTSOURCE_CONTRACTOR, UserStatus.OUTSOURCE_CONSULTANT].includes(userStatus);
}
// 是否为正式在职的人员
export function isEmployedStatus(status: number): boolean {
    return UserStatus.STAFF_STATUS_LIST.includes(status);
}

// 获取用户图标
export const getUserStatusIcon = (userStatus: number) => {
    switch (userStatus) {
        case UserStatus.RECRUIT_INITIAL_SCREENING:
            return <ResumeSvg />;
        case UserStatus.RECRUIT_CERTIFICATION:
            return <PrimaryEvaluationSvg />;
        case UserStatus.RECRUIT_ONLINE_INTERVIEW:
            return <ResumeEvaluationSvg />;
        case UserStatus.PENDING_OFFER:
            return <PendingOnboardSvg />;
        case UserStatus.RECRUIT_PENDING_ONBOARD:
            return <OfferLetterHornSvg />
        default:
            return <PreliminaryEvaluationSvg />
    }
}

// 获取用户状态简称
export const getUserStatusAbbreviation = (userStatus: number) => {
    switch (userStatus) {
        case UserStatus.RECRUIT_INITIAL_SCREENING:
            return '申';
        case UserStatus.RECRUIT_CERTIFICATION:
            return '初';
        case UserStatus.RECRUIT_ONLINE_INTERVIEW:
            return '面';
        case UserStatus.PENDING_OFFER:
            return '录';
        case UserStatus.RECRUIT_PENDING_ONBOARD:
            return '报'
        case UserStatus.TALENT_POOL:
            return '库'
        default:
            return '-'
    }
}

// 获取用户状态颜色
export const getUserStatusColor = (userStatus: number) => {
    switch (userStatus) {
        case UserStatus.RECRUIT_INITIAL_SCREENING:
            return '#236AD4';
        case UserStatus.RECRUIT_CERTIFICATION:
            return '#236AD4';
        case UserStatus.RECRUIT_ONLINE_INTERVIEW:
            return '#B034B3';
        case UserStatus.PENDING_OFFER:
            return '#90C235';
        case UserStatus.RECRUIT_PENDING_ONBOARD:
            return '#CC8A12'
        default:
            return '#236AD4'
    }
}

export const UserStatusFilters = [
    { label: "全部", value: -1 },
    { label: "网申", value: UserStatus.RECRUIT_INITIAL_SCREENING },
    { label: "初评", value: UserStatus.RECRUIT_CERTIFICATION },
    { label: "面试", value: UserStatus.RECRUIT_ONLINE_INTERVIEW },
    { label: "录用", value: UserStatus.PENDING_OFFER },
    // { label: "待接受", value: UserStatus.PENDING_ACCEPTED },
    { label: "报到", value: UserStatus.RECRUIT_PENDING_ONBOARD },
    { label: "试岗", value: UserStatus.PART_TIME_JOB },
    { label: "实习", value: UserStatus.EMPLOYED_INTERNSHIP },
    { label: "试用", value: UserStatus.EMPLOYED_PROBATION },
    { label: "正式", value: UserStatus.EMPLOYED_FORMAL },
    // { label: "人才储备", value: UserStatus.TALENT_POOL },
    { label: "离职", value: UserStatus.HISTORY_RESIGNED },
]

export const getUserStatusName = (value: number): string => {
    switch (value) {
        // ---------------- 招聘阶段 ----------------
        case UserStatus.RECRUIT_INITIAL_SCREENING:
            return "网申";
        case UserStatus.RECRUIT_CERTIFICATION:
            return "初评";
        case UserStatus.TALENT_POOL:
            return "人才储备";
        case UserStatus.RECRUIT_ONLINE_INTERVIEW:
            return "面试";
        case UserStatus.PENDING_OFFER:
            return "录用";
        case UserStatus.RECRUIT_PENDING_ONBOARD:
            return "报到";

        // ---------------- 在职状态 ----------------
        case UserStatus.EMPLOYED_FORMAL:
            return "正式";
        case UserStatus.EMPLOYED_PROBATION:
            return "试用";
        case UserStatus.EMPLOYED_INTERNSHIP:
            return "实习";
        case UserStatus.PART_TIME_JOB:
            return "试岗";

        // ---------------- 历史状态 ----------------
        case UserStatus.HISTORY_NOT_HIRED:
            return "未录用";
        case UserStatus.HISTORY_NOT_ONBOARD:
            return "未报到";
        case UserStatus.HISTORY_RESIGNED:
            return "离职";

        // ---------------- 外协类型 ----------------
        case UserStatus.OUTSOURCE_CONTRACTOR:
            return "外包";
        case UserStatus.OUTSOURCE_CONSULTANT:
            return "顾问";

        default:
            return `未知`;
    }
};

export const getNextUserStatusName = (value: number) => {
    switch (value) {
        case UserStatus.RECRUIT_INITIAL_SCREENING:
            return "初评";
        case UserStatus.RECRUIT_CERTIFICATION:
            return "面试";
        case UserStatus.RECRUIT_ONLINE_INTERVIEW:
            return "录用";
        case UserStatus.PENDING_OFFER:
            return "报到";
        case UserStatus.RECRUIT_PENDING_ONBOARD:
            return "试岗";
        case UserStatus.EMPLOYED_INTERNSHIP:
            return "试用"
        case UserStatus.PART_TIME_JOB:
            return "试用";
        case UserStatus.EMPLOYED_PROBATION:
            return "转正";
        case UserStatus.EMPLOYED_FORMAL:
            return "续签";
        default:
            return ""
    }
}

/**
 * 获得某个用户下一步可流转的状态
 */
export const getNextUserStatus = (value: number) => {
    switch (value) {
        // 人才储备
        case UserStatus.TALENT_POOL:
            return [
                { value: UserStatus.RECRUIT_INITIAL_SCREENING, label: '推选' },
            ];
        // 初筛/网申
        case UserStatus.RECRUIT_INITIAL_SCREENING:
            return [
                { value: UserStatus.TALENT_POOL, label: '储备' },
                { value: UserStatus.RECRUIT_CERTIFICATION, label: '初评' },
                { value: UserStatus.HISTORY_NOT_HIRED, label: '拒绝' },
            ];
        // 初评
        case UserStatus.RECRUIT_CERTIFICATION:
            return [
                { value: UserStatus.TALENT_POOL, label: '储备' },
                { value: UserStatus.RECRUIT_ONLINE_INTERVIEW, label: '面试' },
                { value: UserStatus.HISTORY_NOT_HIRED, label: '拒绝' },
            ];
        // 面试
        case UserStatus.RECRUIT_ONLINE_INTERVIEW:
            return [
                { value: UserStatus.TALENT_POOL, label: '储备' },
                { value: UserStatus.PENDING_OFFER, label: '录用' },
                { value: UserStatus.HISTORY_NOT_HIRED, label: '拒绝' },
            ];
        // 录用
        case UserStatus.PENDING_OFFER:
            return [
                { value: UserStatus.TALENT_POOL, label: '储备' },
                { value: UserStatus.RECRUIT_PENDING_ONBOARD, label: '发送offer' },
                { value: UserStatus.HISTORY_NOT_HIRED, label: '拒绝' },
            ];
        // 待报到
        case UserStatus.RECRUIT_PENDING_ONBOARD:
            return [
                // { value: UserStatus.TALENT_POOL, label: '储备' },
                // { value: UserStatus.EMPLOYED_FORMAL, label: '正式' },
                // { value: UserStatus.EMPLOYED_PROBATION, label: '试用' },
                // { value: UserStatus.EMPLOYED_INTERNSHIP, label: '实习' },
                { value: UserStatus.PART_TIME_JOB, label: '试岗' },
                { value: UserStatus.HISTORY_NOT_ONBOARD, label: '未到岗' },
            ];
        // 试岗
        case UserStatus.PART_TIME_JOB:
            return [
                { value: UserStatus.EMPLOYED_PROBATION, label: '试用' },
                { value: UserStatus.EMPLOYED_INTERNSHIP, label: '实习' },
                { value: UserStatus.HISTORY_RESIGNED, label: '辞退' },
            ];
        // 实习
        case UserStatus.EMPLOYED_INTERNSHIP:
            return [
                { value: UserStatus.EMPLOYED_PROBATION, label: '试用' },
                // { value: UserStatus.HISTORY_RESIGNED, label: '离职' },
            ];
        // 试用
        case UserStatus.EMPLOYED_PROBATION:
            return [
                { value: UserStatus.EMPLOYED_FORMAL, label: '转正' },
                // { value: UserStatus.HISTORY_RESIGNED, label: '离职' },
            ];
        // 正式
        case UserStatus.EMPLOYED_FORMAL:
            return [
                { value: UserStatus.EMPLOYED_FORMAL, label: '续签' },
                // { value: UserStatus.HISTORY_RESIGNED, label: '离职' },
            ];
        default:
            return []
    }
}

// 用户状态排序优先级函数
// 返回值越小优先级越高
export const getUserStatusPriority = (userStatus: number): number => {
    // 在职员工状态 (优先级最高)
    if (UserStatus.STAFF_STATUS_LIST.includes(userStatus)) {
        return 1; // 在职员工
    }

    // 已离职状态 (优先级中等)
    if (userStatus === UserStatus.HISTORY_RESIGNED) {
        return 2; // 已离职
    }

    // 其他状态 (优先级最低)
    return 3; // 其他
};

// user的状态对应的url
export const getUserStatusToUrl = (status: number) => {
    switch (status) {
        case UserStatus.RECRUIT_INITIAL_SCREENING:
            return 'resume-pool';
        case UserStatus.RECRUIT_CERTIFICATION:
            return 'preliminary-evaluation';
        case UserStatus.RECRUIT_ONLINE_INTERVIEW:
            return 'resume-evaluation';
        case UserStatus.PENDING_OFFER:
            return 'offer-letter';
        case UserStatus.RECRUIT_PENDING_ONBOARD:
            return 'onboarding';
        default:
            return "null";
    }
}